import { combineReducers } from 'redux';
import types from './types';

/* State Shape
{
  isShowingPodcastNameCoverArtErrorModal: bool
}
*/

const isShowingPodcastNameCoverArtErrorModalReducer = (
  state = false,
  action
) => {
  switch (action.type) {
    case types.SET_IS_SHOWING_PODCAST_NAME_COVER_ART_ERROR_MODAL:
      return action.payload.isShowingPodcastNameCoverArtErrorModal;
    default:
      return state;
  }
};

const reducer = combineReducers({
  isShowingPodcastNameCoverArtErrorModal: isShowingPodcastNameCoverArtErrorModalReducer,
});

export default reducer;
